var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyPoints(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3206",
    "data-name": "Rectangle 3206",
    width: 58,
    height: 58,
    transform: "translate(46 389)",
    fill: "none",
    stroke: "#0a64f9",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6032",
    "data-name": "Group 6032",
    transform: "translate(-1041 -304)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5908",
    "data-name": "Mask Group 5908",
    transform: "translate(1025 -55)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7527",
    "data-name": "Group 7527",
    transform: "translate(54.457 398.666)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vip",
    d: "M43.514,20.236,38.743,38.6a2.488,2.488,0,0,1-2.4,1.86H9.759a2.488,2.488,0,0,1-2.4-1.86L2.585,20.236a2.483,2.483,0,0,1,3.295-2.946l7.906,3.044a.4.4,0,0,0,.46-.125l6.847-8.777a2.473,2.473,0,0,1,3.915,0l6.847,8.777a.4.4,0,0,0,.46.125l7.906-3.044a2.5,2.5,0,0,1,3.295,2.946Z",
    transform: "translate(-2.503 -10.47)",
    fill: "none",
    stroke: "#232323",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x2: 30.815,
    transform: "translate(5.135 38.109)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeWidth: 3.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPoints);
export default __webpack_public_path__ + "static/media/EmptyPoints.29589aedfab373bf430ca8036f001e33.svg";
export { ForwardRef as ReactComponent };